import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { generalClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import { ACTIVITY_TAG_TYPE } from '../../_constants'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useTagsState = () => React.useContext(Context) || {}
export const useTags = () => useTagsState()?.tags || []

const QUERY = gql`
  query Tags($page: Int, $search: String, $sort: [TagSort], $filter: TagFilter) {
    tags(page: $page, search: $search, sort: $sort, filter: $filter) {
      id
      name
      color
      type
    }
  }
`

const TagsLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const search = useSearch()
  const filter = useCleanFilterForRequest()

  const { data, fetchMore, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      sort: [{ field: field || 'NAME', type }],
      filter: { ...filter, types: [ACTIVITY_TAG_TYPE] }
    },
    client: generalClient
  })

  return (
    <Provider value={data}>
      {/* empty={false}: os `children` aqui são o modal inteiro (cabeçalho com o botão "+ Nova tag"
          + tabela), não só a tabela. Sem isso, com 0 tags o StatePresenter troca TUDO pelo estado
          vazio genérico e some com o botão de criar — sem chance de cadastrar a primeira tag
          (mesmo problema que `TemplatesLoader`/`PermissionsLoader` já evitam com essa mesma flag). */}
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren} empty={false}>
        {children}
      </StatePresenter>
      <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
    </Provider>
  )
}

export default TagsLoader
